module.exports = __webpack_public_path__ + "static/architecture.71a3a2b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/architecture.png
// module id = 1182
// module chunks = 81679748166845